import {logger} from '../services/logger';
import {config, isDotUninitialized, webview} from '../services/measurement';

const ua = window.navigator.userAgent.toLowerCase();

/**
 * Checks if is in iOS webview
 */
const isIOSWebview = () => {
  var safari = /safari/.test(ua);
  var ios = /iphone|ipod|ipad/.test(ua);

  return ios && !window.navigator.standalone && !safari;
};

/**
 * Checks if is in Android webview
 *
 * !!! works for Lollipop and Above (>= Android 5.0) !!!
 */
const isAndroidWebview = () => {
  var android = /android/.test(ua);
  var nativeApp = /appname\/[0-9\.]+$/.test(ua);
  var wv = /wv\)/.test(ua);

  return android && (wv || nativeApp);
};

/**
 * Checks if webview detected and sends info
 * @param {String} userType user type
 */
export const isWebview = userType => {
  const isWV = isIOSWebview() || isAndroidWebview();
  logger(1900, 'Webview: ' + isWV);

  // send hit to reporter if webview is detected
  if (isWV) {
    // in internal script measurement may not be initialized yet
    if (isDotUninitialized()) {
      config(userType);
    }
    webview();
  }

  return isWV;
};
